(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["planner-product-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ef-planner-link] a');
    if (!link) return;
    const wrapper = link.closest('[data-ef-planner-link]');
    const variants = JSON.parse(wrapper.querySelector('[data-planner-variants]').textContent);
    const scope = wrapper.closest('product-information') || wrapper.closest('.shopify-section') || document;
    const input = scope.querySelector('form[action*="/cart/add"] [name="id"]');
    const selectedId = input?.value || new URLSearchParams(location.search).get('variant') || wrapper.dataset.selected;
    const variant = variants.find((entry) => String(entry.id) === String(selectedId)) || variants[0];
    const size = variant.options.join(' ').match(/(\d+)\s*[xх×]\s*(\d+)/i);
    const text = variant.options.join(' ').toLowerCase();
    const frame = text.includes('без рамка') ? 'none' : /бял|white/.test(text) ? 'white' : 'black';
    const url = new URL(link.getAttribute('href'), location.origin);
    url.searchParams.delete('image');
    url.searchParams.delete('title');
    url.searchParams.set('frame', frame);
    if (size) url.searchParams.set('size', `${size[1]}x${size[2]}`);
    link.href = url.href;
  });
  } catch(e) { console.error(e); }
})();

})();
